module.exports = __webpack_public_path__ + "img/voucher-icon-2.bcc0ec46.svg";